(function() {
    angular
      .module('app')
      .directive('arcgisResultItem',arcgisResultItem);

    function arcgisResultItem(){

        return {
            restrict: 'E',
            templateUrl :'app/directives/arcgisResultItem/arcgisResultItem.html',
            scope: {
                result: '=',
                icons: '=',
                showItemStats: '=',
                thumbnailPlaceholders: '=',
                resultTargetWindow: '='
            },
            link: function (scope, el, attrs) {
                window._arcgisResultItem = scope;
                
                scope.thumbnailUrl = scope.result.thumbnailUrl == "" ? scope.thumbnailPlaceholders[0] : scope.result.thumbnailUrl;

                scope.targetWindow = scope.resultTargetWindow || "";

                if(scope.result.snippet && scope.result.snippet.length >520){
                    let _stop = scope.result.snippet.substr(0,500).lastIndexOf(".")+1;
                    if(_stop > -1){
                        scope.result.snippet = scope.result.snippet.substr(0,_stop).trim()
                    }
                    else
                    {
                        let _stop2 = scope.result.snippet.substr(0,500).lastIndexOf(" ");
                        scope.result.snippet = scope.result.snippet.substr(0,_stop2)+"...".trim()
                    }
                }

                if(scope.result.title && scope.result.title.length >115) {
                    let _stop = scope.result.snippet.substr(0, 115)
                    scope.result.title = _stop + '...';
                }

                scope.view = {display: scope.result.searchDisplay || "basic" };

                scope.sceneViewer = scope.result.type.match(/service/i) != null ? true : false;

                scope.openWith = {
                    url: "",
                    label: "",
                    exists: false
                }

                switch (scope.result.type){
                    
                    case 'Feature Service':
                    case 'Map Service':
                    case 'Web Scene':
                        scope.openWith.url = "https://www.arcgis.com/home/webscene/viewer.html?webscene="+scope.result.id;
                        scope.openWith.label = "Open in Scene Viewer";
                        scope.openWith.exists = true;
                        break;

                    case 'CityEngine Web Scene':
                        scope.openWith.url = "https://www.arcgis.com/apps/CEWebViewer/viewer.html?3dWebScene="+scope.result.id;
                        scope.openWith.label = "Open in CityEngine Web Scene";
                        scope.openWith.exists = true;
                        break;

                    case 'Feature Layer': // ??
                    case 'Image Service':
                        scope.openWith.url = "https://www.arcgis.com/home/webmap/viewer.html?useExisting=1&layers="+scope.result.id;
                        scope.openWith.label = "Open in Map Viewer";
                        scope.openWith.exists = true;
                        break;

                    case 'Web Map':
                        scope.openWith.url = "https://www.arcgis.com/home/webmap/viewer.html?webmap="+scope.result.id;
                        scope.openWith.label = "Open in Map Viewer";
                        scope.openWith.exists = true;
                        break;

                    case 'Web Mapping Application':
                        scope.openWith.url = scope.result.url;
                        scope.openWith.label = "View Application";
                        scope.openWith.exists = true;
                        break;
                }

                scope.label = "this is a test: ";
                scope.result.webMapViewerUrl = "https://www.arcgis.com/signin.html?returnUrl=https://www.arcgis.com/home/webmap/viewer.html?useExisting=1&layers="+scope.result.id; 
            }
        }
    }
})();